// InfoTooltip.tsx
import * as Tooltip from '@radix-ui/react-tooltip';
import { Info } from 'lucide-react';

interface InfoTooltipProps {
  content: string;
}

const InfoTooltip = ({ content }: InfoTooltipProps) => {
  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            aria-label="More information"
            className="text-neutral-500 hover:text-neutral-700 focus:outline-none "
          >
            <Info className="w-4 h-5 " />
          </button>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content
            className="z-50 max-w-sm px-3 py-2 text-sm text-white break-words bg-black border rounded-md shadow-lg sm:max-w-sm md:max-w-md lg:max-w-lg w-fit"
            side="top"
            align="center"
            sideOffset={5}
          >
            <span
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <Tooltip.Arrow className="fill-black" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default InfoTooltip;
